import { Injectable } from '@angular/core';

/**
 * State persistence service between drag item and drop zone
 */
@Injectable()
export class DragAndDropListService {
    readonly ALL_EFFECTS = ['move', 'copy', 'link'];
    readonly MIME_TYPE = 'application/x-dnd';
    readonly EDGE_MIME_TYPE = 'application/json';
    readonly MSIE_MIME_TYPE = 'Text';

    private _isDragging: boolean;
    private _itemType: string;
    private _dropEffect: string;
    private _effectAllowed: string;
    private _callback: any;

    set isDragging(isDragging: boolean) {
        this._isDragging = isDragging;
    }

    get isDragging(): boolean {
        return this._isDragging;
    }

    set itemType(itemType: string) {
        this._itemType = itemType;
    }

    get itemType(): string {
        return this._itemType;
    }

    set dropEffect(dropEffect: string) {
        this._dropEffect = dropEffect;
    }

    get dropEffect(): string {
        return this._dropEffect;
    }

    set effectAllowed(effectAllowed: string) {
        this._effectAllowed = effectAllowed;
    }

    get effectAllowed(): string {
        return this._effectAllowed;
    }

    set callback(isDragging: any) {
        this._callback = isDragging;
    }

    get callback(): any {
        return this._callback;
    }

}
